import request from "@/utils/request";

/**
 * 发送验证码
 * @param {*} data
 * @returns
 */
export function fetchSendSms(data) {
  return request({
    url: "/api/sendSMS",
    method: "post",
    data,
  });
}

/**
 * 发送邮箱验证码
 * @param {*} data
 * @returns
 */
export function fetchSendEmail(data) {
  return request({
    url: "/api/sendSMS",
    method: "post",
    data,
  });
}

/**
 *  用户绑定
 * @param {*} data
 * @returns
 */
export function fetchUserBind(data) {
  return request({
    url: "/api/user/bind",
    method: "post",
    data,
  });
}

/**
 * @param {object} [data={}]
 * @returns {object}
 */
export function fetchUserRegister(data = {}) {
  return request({
    url: "/api/user/register",
    method: "post",
    data,
  });
}

/**
 * 获取自己的用户信息
 * @param {*} data
 * @returns
 */
export function fetchUserInfo(data = {}) {
  return request({
    url: "/api/user/get",
    method: "post",
    data,
  });
}

/**
 * 获取用户个人信息
 * @param {object} [data={}]
 * @returns {object}
 */
export function fetchUCUserInfo(data={}){
    return request({
        url: "/api/user/uc",
        method: "get",
        params: data
    })
}
/**
 * 更新用户个人信息
 * @param {object} [data={}]
 * @returns {object}
 */
export function fetchUpdateUserInfo(data = {}) {
    return request({
        url: "/api/user/update",
        method: "put",
        data
    })
}

/**
 * 更新密码
 * @param {object} [data={}]
 * @returns {object}
 */
export function fetchUpdatePassword(data = {}) {
  return request({
      url: "/api/user/updatePassword",
      method: "put",
      data
  })
}